import { gql } from '@apollo/client';

// ============================================================================
// Shop item lookup (used to link CRM articles to /shop/artikel/{itemId})
// ============================================================================

export const ITEM_BY_PAEFFGEN_SKU_QUERY = gql`
  query ItemByPaeffgenSKU($pfgnSKU: String!) {
    getItemByPaeffgenSKU(pfgnSKU: $pfgnSKU) {
      id
    }
  }
`;

export interface ItemByPaeffgenSKUVariables {
  pfgnSKU: string;
}

export interface ItemByPaeffgenSKUResult {
  getItemByPaeffgenSKU: { id: string } | null;
}
